import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-979c71a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_more" }
const _hoisted_2 = { class: "modal_item" }
const _hoisted_3 = {
  key: 0,
  class: "modal_item modal_text"
}
const _hoisted_4 = {
  key: 1,
  class: "modal_item modal_text"
}
const _hoisted_5 = {
  key: 2,
  class: "modal_item"
}
const _hoisted_6 = { class: "modal_text modal_item_num" }
const _hoisted_7 = { class: "modal_item" }
const _hoisted_8 = {
  key: 3,
  class: "modal_item modal_text"
}
const _hoisted_9 = {
  key: 4,
  class: "modal_item modal_text"
}

import { ref, unref, watch } from 'vue';
import { MoreFormType } from '../type';
import { Radio, InputNumber } from 'ant-design-vue';
import { InfoCircleFilled } from '@ant-design/icons-vue';
interface IPorp {
  modelValue: MoreFormType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoreModal',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: MoreFormType;
};

const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aInputNumber = InputNumber;



const form = ref<MoreFormType>({ answer_mode: 0, answer_operation: 0 });
form.value = unref(props.modelValue);

watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" 答题方式： "),
      _createVNode(_unref(aRadioGroup), {
        name: "radioGroup",
        value: form.value.answer_mode,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.answer_mode) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(aRadio), { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("必填答对")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadio), { value: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("全对")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadio), { value: 3 }, {
            default: _withCtx(() => [
              _createTextVNode("答对数量")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (form.value.answer_mode === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(InfoCircleFilled)),
          _createTextVNode(" 设置必填项，至少设置一项必填且必填项答对才能进入！ ")
        ]))
      : _createCommentVNode("", true),
    (form.value.answer_mode === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(InfoCircleFilled)),
          _createTextVNode(" 设置全对，所有的题目必须全部答对才能进入！ ")
        ]))
      : _createCommentVNode("", true),
    (form.value.answer_mode === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createTextVNode(" 答题数： "),
          _createVNode(_unref(aInputNumber), {
            id: "inputNumber",
            value: form.value.answer_count,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.answer_count) = $event)),
            class: "modal_item_act"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(InfoCircleFilled)),
            _createTextVNode(" 设置答对数量，达到设置的正确率将会成功进入！")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createTextVNode(" 答题操作： "),
      _createVNode(_unref(aRadioGroup), {
        name: "radioGroup",
        value: form.value.answer_operation,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.answer_operation) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(aRadio), { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("重新答题")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadio), { value: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("答错失效")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (form.value.answer_operation === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(InfoCircleFilled)),
          _createTextVNode(" 答题完毕之后，答错可以重新答题 ")
        ]))
      : _createCommentVNode("", true),
    (form.value.answer_operation === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_unref(InfoCircleFilled)),
          _createTextVNode(" 所有题目答错，将失去机会不允许再次答题 ")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})